/**
 * Role rules the global router guard applies, kept apart from the router so they can be tested
 * without booting it.
 */

const CREW_ROLES = ['FIELD_STAFF', 'CONTRACTOR'];

/**
 * The only routes a crew-only user may open; anything else sends them Home.
 *
 * @type {readonly string[]}
 */
export const CREW_ROUTES = Object.freeze([
    'Home',
    'SelectTenant',
    'TaskDetail',
    'My account',
    'Account',
    'FieldStaffSchedule',
    'FieldStaffNotifications',
    'FieldStaffRunsheets',
    'FieldStaffRunsheetShow',
    'CompanyDiary',
    'FormsIndex',
    'FormsFill',
    'FormsSubmissionsIndex',
    'FormsSubmissionsView',
    'TimesheetStaff',
    'TimesheetView',
    'WeeklyTimesheet',
    'JobsIndex',
    'OrderView',
    'OrderPreJobChecklist',
    'OrderInventory',
    'OrderInventoryConditionReport',
    'IcrSignOff',
    'IcrViewSignedOff',
    'OrderNotFound',
    'Help',
    '403Page',
    '404Page',
    '503Page',
]);

/**
 * Whether a route's deny list refuses this user.
 *
 * A denied role refuses only when the user holds no role the route admits: every role they hold
 * is either denied or a crew role. So Ops + Sales passes a Sales denial, while Sales + Field Staff
 * does not. A user with no roles in the tenant (a platform user) holds no denied role and passes.
 *
 * @param {string[]} roles the user's roles in the current tenant
 * @param {string[]|null} denyRoles the route's deny list
 * @returns {boolean}
 */
export function isRefusedByDenyRoles(roles, denyRoles) {
    if (!denyRoles?.length || !roles.some((role) => denyRoles.includes(role))) {
        return false;
    }

    return roles.every((role) => denyRoles.includes(role) || CREW_ROLES.includes(role));
}
